import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API, BASE_PATH_APP } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAll: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants`,
        params: {
            '$count': true
        }
    },
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id`
    },
    getDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/details`
    },
    getApplicationScreeningPersonalInformationFieldsForApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/screeningPrefill`
    },
    getApplicationScreeningScreeningSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/screeningSummary`
    },
    update: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/:id`
    },
    add: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants`
    },
    recordFee: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/recordfee`
    },
    updateStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/:applicantId/status`
    },
    sendRentalApplicationEmail: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/:applicantId/sendRentalApplicationEmail`
    },
    getApplicantAsResident: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:applicantId/asResident`
    },
    getApplicantTrackingInfoForApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:applicantId/applicantTrackingInfo`
    },
    getApplicationReceivePaymentDefaults: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:applicationId/receivePaymentDefaults`
    },
    getACHDDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/GetACHDDetails`
    },
    getACHDDetailsByProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/GetACHDDetails/:propertyId`
    },
    getPaymentMethodSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/GetPaymentMethodSettings`
    },
    receiveApplicationFeePayment: {
        method: 'POST',
        url: `${BASE_PATH_API}/applications/fee/payment`
    },
    submitCreditCardPayment: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/:applicantId/creditCardPayment`
    },
    getAwatChecklistForApplicant: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/awat/checklist`,
        transformResponse: function transformResponse(response) {
            if (response && response.Id > 0) {
                return response;
            }
            return null;
        }
    },
    getApplicationCosigner: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/applicationCosigner`
    },
    updateApplicantNameAndBuilding: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/:applicantId/propertyUnit`
    },
    deleteApplicant: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicants/:id`
    },
    canDeleteApplicant: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:applicantId/canDelete`
    },
    getApplicantChecklists: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/checklists`,
        isArray: true
    },
    saveApplicantChecklists: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/:id/checklists`
    },
    updateChecklistItem: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/checklistItem`
    },
    orderChecklistItem: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/orderChecklistItem`
    },
    createChecklistItem: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/checklistItem`
    },
    deleteChecklistItem: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicants/checklistItem`
    },
    saveDefaultLists: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/:id/defaultLists`
    },
    createApplicantNote: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicants/:id/note`
    },
    getApplicantUpdates: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/history`
    },
    deleteApplicantNote: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicants/:applicantId/notes/:id`
    },
    isChecklistTemplateOverridden: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/isChecklistTemplateOverridden`
    },
    getPropertyPaymentSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/propertyOperatingBankAccountInfo/:propertyId`
    },
    getRentalApplicationFeeSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/feeSettings`
    },
    getApplicantsNotInGroups: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/notInGroups`
    },
    updateApplicantsGroup: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/applicants`
    },
    removeApplicantsGroup: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicants/group`
    },
    updateStatusForApplicants: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/applicants/status`
    },
    createUserForExistingApplicant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/:applicantId/createUser`
    },
    toggleApplicantUserAccountAccess: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/:applicantUserId/access`
    },
    updateApplicantUserInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/users/:applicantUserId`
    },
    resetApplicantUserPassword: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicants/:id/password`
    },
    signInAsUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/signIn`
    },
    checkApplicantExistSameEmail: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/email`,
        params: {
            'email': ':email'
        }
    },
    getApplicantsWithBadApplicationData: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/badApplicationData`,
    },
    getApplicantEventHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/eventHistory`,
        isArray: true
    },
    getApplicantNotesAndAttachments: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/notesAndAttachments`,
        isArray: true
    },
    hasApplicants: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/hasApplicants`
    },
    hasLedgerTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:applicationId/hasLedgerTransactions`
    },
    getAutomatedScreeningError: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicants/:id/automatedScreeningError`
    }
};

export function ApplicantsApi(APPLICATION_SUMMARY_TAB) {
    const service = createActions(actions);
    service.getSummaryLink = function getSummaryLink(applicantId, tabId) {
        let applicantPageUrl = `${BASE_PATH_APP}`;
        if (tabId === APPLICATION_SUMMARY_TAB.Application) {
            applicantPageUrl += `/leasing/applicant/${applicantId}/application`;
        } else if (tabId === APPLICATION_SUMMARY_TAB.Screening) {
            applicantPageUrl += `/leasing/applicant/${applicantId}/screening`;
        } else if (tabId === APPLICATION_SUMMARY_TAB.Fee) {
            applicantPageUrl += `/leasing/applicant/${applicantId}/fee`;
        } else if (tabId === APPLICATION_SUMMARY_TAB.RentalHistoryVerification) {
            applicantPageUrl += `/leasing/applicant/${applicantId}/rentalHistoryVerification`;
        } else {
            applicantPageUrl += `/leasing/applicant/${applicantId}/summary`;
        }
        return applicantPageUrl;
    };
    return service;
}
ApplicantsApi.$inject = ['APPLICATION_SUMMARY_TAB'];
